import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CompanyService } from '../../../features/services/company.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-voucher-home',
  imports: [RouterModule, NgxSpinnerModule],
  templateUrl: './voucher-home.component.html',
  styleUrl: './voucher-home.component.css'
})
export class VoucherHomeComponent {
  constructor(
    private router: Router,
    private ngx: NgxSpinnerService,
    private companyService: CompanyService,
    private headerService: HeaderService,
  ) {
  }

  ngOnInit(): void {
  //  this.callSecureApi();
   this.headerService.setCompanyName(sessionStorage.getItem('companyName') || '');   
  }

  voucherSetup() {
    this.router.navigate(['/voucher-setup']);
  }

  viewVoucher()
  {
    this.router.navigate(['/voucher-list']);
  }

  callSecureApi(): void {
    this.companyService.secure().subscribe({
        next: res => {
          sessionStorage.setItem('companyId', res.companyId);
          sessionStorage.setItem('email', res.userEmail);
          sessionStorage.setItem('roleCode', res.roleCode);
          sessionStorage.setItem('companyName', res.companyName);
          this.headerService.setCompanyName(res.companyName);
          this.ngx.hide();
          this.router.navigate(['/home']);
        },
        error: err => {          
          this.ngx.hide();
          this.router.navigate(['']);
          console.error('API error', err);
        }
      });   
  }
}
